import { render, staticRenderFns } from "./createUnit.vue?vue&type=template&id=4d24dfde"
import script from "./createUnit.vue?vue&type=script&lang=js"
export * from "./createUnit.vue?vue&type=script&lang=js"
import style0 from "./createUnit.vue?vue&type=style&index=0&id=4d24dfde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports